module.exports = __webpack_public_path__ + "nquick_report_icon.svg";